import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { PushPin } from "@phosphor-icons/react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi } from "@/lib/api";
import { RANGES } from "@/lib/chartRange";

export const useChartRange = () => {
  const api = useApi();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["preferences"], queryFn: () => api.get("/preferences"), staleTime: Infinity });
  const [range, setRange] = useState(null);
  useEffect(() => { if (data && range === null) setRange(data.chart_range); }, [data, range]);
  const saveDefault = async () => {
    try {
      qc.setQueryData(["preferences"], await api.put("/preferences", { chart_range: range }));
      toast.success(`${RANGES.find(([k]) => k === range)[1]} is now your default view`);
    } catch { toast.error("Couldn't save your default view"); }
  };
  return { range: range || data?.chart_range || "all", setRange, isDefault: data?.chart_range === range, saveDefault };
};

export const RangePicker = ({ range, setRange, isDefault, saveDefault }) => (
  <div className="flex items-center gap-2">
    <Select value={range} onValueChange={setRange}>
      <SelectTrigger data-testid="chart-range-select" className="h-8 w-40 rounded-full bg-[#050505] border-[#2A2A2A] text-xs font-mono"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-[#121212] border-[#2A2A2A]">
        {RANGES.map(([k, label]) => <SelectItem key={k} value={k} data-testid={`chart-range-option-${k}`} className="text-xs">{label}</SelectItem>)}
      </SelectContent>
    </Select>
    <button data-testid="chart-range-default-btn" onClick={saveDefault} disabled={isDefault} title={isDefault ? "This is your default view" : "Make this my default view"}
      className={`flex items-center gap-1 rounded-full border px-3 h-8 text-[11px] transition-colors ${isDefault ? "border-[#00FF9D]/40 text-[#00FF9D]" : "border-[#2A2A2A] text-[#A3A3A3] hover:border-[#00FF9D] hover:text-[#00FF9D]"}`}>
      <PushPin size={12} weight={isDefault ? "fill" : "regular"} /> {isDefault ? "Default" : "Set default"}
    </button>
  </div>
);
